<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState,mapGetters,mapActions } from "vuex"
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Salary Allowances",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Salary Allowances",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Salary Allowances",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "staff",
          sortable: true,
          label: "STAFF",
        },
        {
          key: "month_year",
          sortable: true,
          label: "MONTH-YEAR",
        },
        {
          key: "amount_paid",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "date",
          sortable: true,
          label: "DISBURSED ON",
        },
        {
          key: "mode_field",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingPayroll: [],
      staffError: "",
      amountError: "",
      modeError: "",
      dateError: "",
      monthError: "",

      // Value from user input for adding unit
      data: {
        staff: "",
        month_year: "",
        amount_paid:"",
        mode:"",
        date:"",
      },
      // edit unit
      editdata: {
        amount_paid:"",
        staff:"",
        id: "",
      },
      // delete unit
      deletedata: {
        staff: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("staff", ["StaffSave", "Staff", "StaffAllowances"]),
    ...mapGetters("auth", ["MyUserPerm","branchid"]),
    ...mapGetters("setting", ["PaymentOptions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.StaffAllowances ? this.StaffAllowances.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.StaffAllowances ? this.StaffAllowances.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);        
        if (this.type == "success") {
          this.resetAdd();
          this.resetEdit();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchStaff: "staff/fetchStaff",
      AddStaffAllowances: "staff/addStaffAllowance",
      FetchStaffAllowances: "staff/fetchStaffAllowances",
      EditStaffAllowances: "staff/editStaffAllowance",
      DeleteStaffAllowances: "staff/deleteStaffAllowance",
      FetchModes: "setting/fetchPaymentOptions",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addStaffAllowances(modalId) {
      this.modal_id = modalId;

      if (this.data.staff === "") {
        this.staffError = "Staff field is required";
      } else if (this.data.amount_paid === "") {
        this.amountError = "Amount Paid field is required";
        return;
      } else if (this.data.mode === "") {
        this.modeError = "Payment mode field is required";
        return;
      } else if (this.data.date === "") {
        this.dateError = "Date field is required";
        return;
      } else if (this.data.month_year === "") {
        this.dateError = "Month field is required";
        return;
      }   

      this.AddStaffAllowances(this.data);
    },

    resetAdd() {
      this.data.staff = "";
      this.data.amount_paid = "";
      this.data.date = "";
      this.data.mode = "";
      this.data.month_year = "";
      this.modal_id = "";
    },
    resetEdit() {
      this.editdata.amount_paid = "";
      this.editdata.staff = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.staff = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.staffError = "";
      this.amountError = "";
      this.dateError = "";
      this.modeError = "";
      this.mobthError = "";
    },

    showEditModal(val) {
      this.editdata.staff = val.item.staff;
      this.editdata.amount_paid = val.item.amount_paid;
      this.editdata.id = val.item.id;
    },

    editStaffAllowances(modalId) {
      this.modal_id = modalId;

      if (this.editdata.amount_paid === "") {
        this.amountError = "Amount Paid field is required";
        return;
      }
      
      this.EditStaffAllowances(this.editdata);
    },

    showDeleteModal(val) {
      this.deletedata.staff = val.item.staff;
      this.deletedata.id = val.item.id;
    },
    
    deleteStaffAllowances(modalId) {
      this.modal_id = modalId;
      this.DeleteStaffAllowances(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCommas(){
      this.data.amount_paid = this.thousandSeprator(this.data.amount_paid);
      this.editdata.amount_paid = this.thousandSeprator(this.editdata.amount_paid);
    }
  },
  created() {
    this.FetchStaff();
    this.FetchStaffAllowances();
    this.FetchModes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">Staff Allowances</h4>
              </div>
              <div v-if="MyUserPerm.add_staff_salaries == 1 && branchid != 0" class="col-md-3" align="right">
                <b-button v-b-modal.add_staffallowance-modal variant="primary">Record Allowance</b-button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="StaffAllowances?StaffAllowances:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(mode_field)="data">
                  {{ data.item.mode.name }} ({{ data.item.mode.type_name }}-{{ data.item.mode.account_number }})
                </template>
                <template #cell(actions)="data">
                <b-button-group>
                  <b-button
                      v-if="MyUserPerm.edit_staff_salaries == 1"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-allowance-modal
                      @click="showEditModal(data)"
                  ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                      size="sm"
                      v-if="MyUserPerm.delete_staff_salaries == 1"
                      variant="danger"
                      v-b-modal.delete-allowance-modal
                      @click="showDeleteModal(data)"
                  ><i class="fa fa-trash"></i></b-button
                  >
                </b-button-group>
                </template>
              </b-table>
            </div>
            <Loader  v-if="!StaffAllowances"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal id="add_staffallowance-modal" no-close-on-backdrop
    no-close-on-esc hide-footer>
      <template #modal-title> Add Allowance Payment</template>

      <div class="row">
        <div class="form-group mb-3">
          <label>Staff</label>
          <div class="input-group">
            <model-list-select
                :list="Staff ? Staff : []"
                v-model="data.staff"
                option-value="id"
                option-text="name"
                placeholder="Select staff"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="staffError">
            <em>{{ staffError }}</em>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Amount Disbursed</label>
          <div class="input-group">
            <input
                type="text"
                placeholder="Enter Amount Paid"
                class="form-control"
                v-model="data.amount_paid"
                @input="addCommas(), resetError()"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Month-Year</label>
          <div class="input-group">
            <input
                type="month"
                class="form-control"
                v-model="data.month_year"
                @input="resetError()"
            />
            <div class="text-danger" v-if="monthError">
              <em>{{ monthError }}</em>
            </div>
          </div>
        </div> 

        <div class="form-group mb-3">
          <label>Disbursed on</label>
          <div class="input-group">
            <input
                type="date"
                class="form-control"
                v-model="data.date"
                @input="resetError()"
            />
            <div class="text-danger" v-if="dateError">
              <em>{{ dateError }}</em>
            </div>
          </div>
        </div> 

        <div class="form-group mb-3">
          <label>Payment Method</label>
          <model-list-select
            :list="PaymentOptions ? PaymentOptions : []"
            v-model="data.mode"
            option-value="id"
            option-text="mode"
            placeholder="Select Method"
            @input="resetError()"
          >
          </model-list-select>
          <div class="text-danger" v-if="modeError">
            <em>{{ modeError }}</em>
          </div>
        </div>        
      </div>      

      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add_staffallowance-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="addStaffAllowances('add_staffallowance-modal')"
        > <i class="fa fa-check"></i>
          Submit
          <b-spinner
              v-if="StaffSave"
              variant="light"
              small
              label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- edit modal starts -->
        <b-modal id="edit-allowance-modal" hide-footer>
          <template #modal-title> Edit Staff {{ editdata.staff }}</template>
          <div class="row">
            <div class="form-group mb-3">
              <label>Amount Disbursed</label>
              <div class="input-group">
                <input
                    type="text"
                    placeholder="Enter Amount Paid"
                    class="form-control"
                    v-model="editdata.amount_paid"
                    @input="addCommas(), resetError()"
                />
              </div>
              <div class="text-danger" v-if="amountError">
                <em>{{ amountError }}</em>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                @click="closeModal('edit-allowance-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
                type="button"
                class="btn btn-primary"
                @click="editStaffAllowances('edit-allowance-modal')"
            > <i class="fa fa-check"></i>
              Save Changes
              <b-spinner
                  v-if="StaffSave"
                  variant="light"
                  small
                  label="Saving"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal
        header-bg-variant="danger"
        header-text-variant="light"
        body-text-variant="danger"
        footer-bg-variant="danger"
        footer-text-variant="danger"
        id="delete-allowance-modal"
        hide-footer
        @hidden="resetDelete"
    >
      <template #modal-title> Delete Allowance payment for Staff {{ deletedata.staff }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this record? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-allowance-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-danger"
            @click="deleteStaffAllowances('delete-allowance-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
              v-if="StaffSave"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
.btn-xs {
  padding: .25rem .4rem;
  font-size: .875rem;
  line-height: .5;
  border-radius: .2rem;
}
</style>
